import { Component, Input } from '@angular/core';

/**
 * * Componente para exibição dos passos de um formulário.
 */
@Component({
  selector: 'ui-steps-panel',
  templateUrl: './steps-panel.component.html',
  styleUrls: ['./steps-panel.component.scss']
})
export class StepsPanelComponent {

  /**
   * * Lista com as descrições dos passos.
   */
  @Input() steps!: String[];

  /**
   * * Número do passo atual selecionado.
   */
  @Input() currentStep: number = 1;

  constructor() { }
}
